/**
 * Load and render PDF pages with pdf.js (page-by-page viewer).
 */
export async function loadPdfDocument(blobOrArrayBuffer) {
  const pdfjsLib = await import('pdfjs-dist/webpack.mjs');
  const data = blobOrArrayBuffer instanceof ArrayBuffer
    ? blobOrArrayBuffer
    : await blobOrArrayBuffer.arrayBuffer();
  return pdfjsLib.getDocument({ data }).promise;
}

export async function renderPdfPageToCanvas(pdf, pageNumber, canvas, { maxWidth = 800 } = {}) {
  const page = await pdf.getPage(pageNumber);
  const baseViewport = page.getViewport({ scale: 1 });
  const scale = maxWidth / baseViewport.width;
  const viewport = page.getViewport({ scale });
  const ctx = canvas.getContext('2d', { alpha: false });
  if (!ctx) throw new Error('Canvas 2D context unavailable');

  const dpr = window.devicePixelRatio || 1;
  canvas.width = Math.floor(viewport.width * dpr);
  canvas.height = Math.floor(viewport.height * dpr);
  canvas.style.width = `${viewport.width}px`;
  canvas.style.height = `${viewport.height}px`;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  await page.render({ canvasContext: ctx, viewport }).promise;
  return { viewport, width: viewport.width, height: viewport.height };
}
